export function PageHeader({ title, description, actions, testId }) {
  return (
    <div className="mb-8 flex items-start justify-between gap-4" data-testid={testId}>
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-zinc-50">{title}</h1>
        {description && <p className="mt-1 text-sm text-zinc-400">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, icon: Icon, testId }) {
  return (
    <div className="rounded-md border border-zinc-800 bg-zinc-900/30 p-5" data-testid={testId}>
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wider text-zinc-500">{label}</span>
        {Icon && <Icon className="h-4 w-4 text-zinc-600" />}
      </div>
      <div className="mt-3 font-mono text-3xl font-semibold text-zinc-50">{value}</div>
      {hint && <div className="mt-1 text-xs text-zinc-500">{hint}</div>}
    </div>
  );
}

export function EmptyState({ title, description, action, testId }) {
  return (
    <div className="rounded-md border border-dashed border-zinc-800 bg-zinc-900/20 px-6 py-16 text-center" data-testid={testId}>
      <h3 className="text-base font-medium text-zinc-200">{title}</h3>
      {description && <p className="mx-auto mt-2 max-w-md text-sm text-zinc-500">{description}</p>}
      {action && <div className="mt-6 flex justify-center">{action}</div>}
    </div>
  );
}
